/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Tabs } from 'antd'
// import './index.scss'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'

import CTC from './ctc'
import Certificates from './certificates'

const { TabPane } = Tabs

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
		}
        
	}


	render() {

		return (
			<Row className='container'>
				<Tabs defaultActiveKey="ctc" tabPosition='left'>
					<TabPane tab="Community Tax Certificate" key="ctc">
						<CTC />
					</TabPane>
					<TabPane tab="Other Collections" key="others">
						<Certificates />
					</TabPane>
				</Tabs>
			</Row>
		)
	}
}


const composed = compose(
	inject('AuthStore'),
	observer
)

export default composed(Index)
